/* eslint-disable camelcase */
import HttpService from './httpService';
import config from '../../config';

class DescuentosApiService extends HttpService {
  async listarDescuentos({ headquarter }) {
    return this.get('listarDescuentos', { params: { headquarter } });
  }

  async obtenerDescuento({ headquarter, id }) {
    return this.get('obtenerDescuento', { params: { headquarter, id } });
  }

  async crearDescuento({
    headquarter, descuento, porcentaje, fecha_inicio, fecha_fin,
  }) {
    return this.post('crearDescuento', {
      headquarter,
      descuento,
      porcentaje,
      fecha_inicio,
      fecha_fin,
    });
  }

  async actualizarDescuento({
    headquarter, id, descuento, porcentaje, fecha_inicio, fecha_fin,
  }) {
    const body = { headquarter, id };
    if (descuento !== undefined) body.descuento = descuento;
    if (porcentaje !== undefined) body.porcentaje = porcentaje;
    if (fecha_inicio !== undefined) body.fecha_inicio = fecha_inicio;
    if (fecha_fin !== undefined) body.fecha_fin = fecha_fin;
    return this.put('actualizarDescuento', body);
  }

  async eliminarDescuento({ headquarter, id }) {
    return this.delete('eliminarDescuento', { data: { headquarter, id } });
  }
}

const descuentosApiService = new DescuentosApiService(config.REACT_APP_NODE_API);
export default descuentosApiService;
